import React from 'react'
import DataSource from '../DataSource'
import Heading from '../components/Heading'
import CountrySearch from '../components/CountrySearch'
import ResponsiveTable from '../components/ResponsiveTable'
import ModuleWithLoader from '../components/ModuleWithLoader'
import AjaxLoader from '../components/AjaxLoader'
import AjaxLoaderImg from '../components/AjaxLoaderImg'

class VoipInternationCallRates extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            noResult: false,
            isLoadingRates: false,
            search: '',
            rates: []
        }
    }

    handleChange (event) {
        this.setState({
            search: event.target.value,
            noResult: false
        }, this.getData.bind(this))
    }

    getData () {
        if (this.state.search.trim().length > 1) {
            clearTimeout(this.timer)

            this.setState({
                isLoadingRates: true,
                rates: []
            })

            this.timer = setTimeout(() => {
                DataSource.getData(`/api/searchVoipInternationalRates/${this.state.search}`, result => {
                    this.setState({ isLoadingRates: false })
                    if (result.length > 0) {
                        this.setState({ rates: result })
                    } else {
                        this.setState({ noResult: true })
                    }
                }, () => {
                    this.setState({ hasError: true })
                })
            }, 500)
        }
    }

    render () {
        const TableData = {
            headings: ['Destination', 'Price (inc. GST)'],
            rows: this.state.rates
        }

        const Result = () => {
            if (this.state.isLoadingRates) {
                return <div className='w-100 text-center'><AjaxLoaderImg /></div>
            } else if (this.state.noResult) {
                return <div className='text-center'>No results found for "{this.state.search}".</div>
            } else if (this.state.rates.length > 0) {
                return <ResponsiveTable data={TableData} />
            } else {
                return <div className='text-center'>Start typing the country to find the rates.</div>
            }
        }

        return (
            <div className='buy-usage-data module' style={{ overflow: 'visible' }}>
                <Heading title='International call rates' />
                <ModuleWithLoader isLoaded hasError={this.state.hasError} className='p-4 pb-lg-5'>
                    <div className='row mb-4'>
                        <div className='col-12 text-center'>
                            <p>All rates are price per minute but are billed per second.<br />No flag fall applies to any destination.</p>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col-12 col-lg-8 offset-lg-2'>
                            <CountrySearch title='Find your rates:' search={this.state.search} countryList={[]} handleChange={this.handleChange.bind(this)} handleSelect={() => {}} />
                            {Result()}
                        </div>
                    </div>
                </ModuleWithLoader>
            </div>
        )
    }
}

export default VoipInternationCallRates



// WEBPACK FOOTER //
// ./resources/js/modules/InternationalCallRates.js